import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import Bind from 'lodash-decorators/bind';

import { isOnMobile } from 'utils/device-utils';
import LanguageService from 'services/Language.service';

import messages from './PressRoomListingView.intl';
import pressNoteMdMessages from './PressNoteMd.intl';
import pressNoteSmMessages from './PressNoteSm.intl';

import { ANCHOR } from 'common/consts/common';
import { STATIC_TAXONOMY } from 'common/consts/staticTaxonomy';
import { LOAD_STATES } from 'common/consts/common';
import { generateYearsFilterArray } from 'utils/date-utils';

//components
import ArticlesPage from 'common/components/ArticlesPage/ArticlesPage';
import PageNotFound from 'views/PageNotFound/PageNotFoundView';

import PressRoomNewsStore from 'stores/PressRoomNews.store';
import TaxonomyStore from 'stores/Taxonomy.store';
import { observer } from 'mobx-react';
import { observable, reaction, action, computed, runInAction } from 'mobx';
import ContentStore from 'stores/Content.store';

@injectIntl
@withRouter
@observer
export default class PressRoomListingView extends Component {
  taxonomies = TaxonomyStore;
  filtersList = generateYearsFilterArray({
    first: {
      text: this.props.intl.formatMessage(messages.filter),
      value: ''
    },
    from: 2017
  });

  state = {
    isMobile: isOnMobile(),
    selectedFilter: this.props.match.params.category
      ? this.filtersList.find(
          filter => filter.value === this.props.match.params.category
        )
      : this.filtersList[0]
  };

  criteria = observable({
    page: PressRoomNewsStore.latestState.page,
    category: PressRoomNewsStore.latestState.category,
    publishYear:
      this.state.selectedFilter || PressRoomNewsStore.latestState.publishYear
  });

  latestNews = observable([]);
  loadState = observable.box('');
  isExploited = false;

  currentLanguage = LanguageService.getLang();
  tagsList = [
    {
      name: this.props.intl.formatMessage(messages.tag1),
      anchor: ANCHOR.CASESTUDIES[this.currentLanguage]
    },
    {
      name: this.props.intl.formatMessage(messages.tag2),
      anchor: ANCHOR.TEAMOFEXPERTS[this.currentLanguage]
    },
    {
      name: this.props.intl.formatMessage(messages.tag3),
      anchor: ANCHOR.MEDIAABOUTUS[this.currentLanguage]
    }
  ];

  async componentDidMount() {
    window.addEventListener('resize', this.updateDimensions);

    reaction(() => this.criteria.category, () => this.latestNews.clear());
    reaction(() => this.criteria.publishYear, () => this.latestNews.clear());

    PressRoomNewsStore.fetchOtherPressRoomNews();
  }

  componentDidUpdate(prevProps) {
    const { category } = this.props.match.params;

    if (category !== prevProps.match.params.category) {
      const selectedFilter = category
        ? this.filtersList.find(filter => filter.value === category)
        : this.filtersList[0];

      this.setState({ selectedFilter });

      this.updateCriteria({
        publishYear: selectedFilter,
        page: 1
      });
    }
  }

  componentWillUnmount() {
    if (!this.state.selectedFilter) {
      return;
    }

    PressRoomNewsStore.latestState = {
      data: [...this.latestNews],
      page: this.criteria.page,
      isExploited: this.isExploited,
      category: this.criteria.category,
      publishYear: this.criteria.publishYear
    };

    window.removeEventListener('resize', this.updateDimensions);
  }

  async fetchLatestPressRoomNews(criteria) {
    PressRoomNewsStore.fetchOtherPressRoomNews();
    const { data } = await PressRoomNewsStore.fetchLatestPressRoomNews(
      criteria
    );

    runInAction(() => {
      this.latestNews.push(...data);

      PressRoomNewsStore.latestState.data = [];
    });
  }

  @Bind()
  onCategoryChange(category) {
    this.updateCriteria({
      category,
      page: 1
    });
  }

  @action
  updateCriteria(newCriteria) {
    Object.assign(this.criteria, newCriteria);
    this.fetchLatestPressRoomNews(this.criteria);
  }

  @Bind()
  async showMore() {
    this.updateCriteria({
      page: this.criteria.page + 1
    });
  }

  @computed
  get otherNews() {
    return PressRoomNewsStore.otherPressRoomNews;
  }

  @computed
  get isLoaded() {
    return this.loadState.get() === LOAD_STATES.LOADED;
  }

  @computed
  get categoryList() {
    const taxonomyTerms = this.taxonomies.getTaxonomyByName(
      STATIC_TAXONOMY.PRESS_ROOM.codename
    );
    const defaultOption = {
      text: this.props.intl.formatMessage(messages.taxonomyAll),
      value: ''
    };

    if (taxonomyTerms) {
      const categoriesOptions = taxonomyTerms.map(item => ({
        text: item.name,
        value: item.codename
      }));
      return [defaultOption, ...categoriesOptions];
    } else {
      return [defaultOption];
    }
  }

  render() {
    const { intl } = this.props;
    const { selectedFilter } = this.state;
    if (!this.state.selectedFilter) {
      return <PageNotFound />;
    }

    return (
      <ArticlesPage
        intl={intl}
        messages={messages}
        categoryList={this.categoryList}
        tagsList={this.tagsList}
        categorySlug={ANCHOR.PRESSROOM}
        filtersList={this.filtersList}
        selectedFilter={selectedFilter}
        criteria={this.criteria}
        criteriaKey={this.criteriaKey}
        fetchLatestNews={this.fetchLatestPressRoomNews}
        seoContent={ContentStore.content && ContentStore.content.pressRoomSEO}
        onCategoryChange={this.onCategoryChange}
        showMore={this.showMore}
        latestNews={this.latestNews}
        isExploited={this.isExploited}
        articleNoteMdMessages={pressNoteMdMessages}
        articleNoteSmMessages={pressNoteSmMessages}
        otherNews={PressRoomNewsStore.otherPressRoomNews}
        person={
          ContentStore.content && ContentStore.content.pressRoomContactPerson
        }
        categoryPath="news.pressRoomCategory.value"
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/PressRoomListing/PressRoomListingView.js